import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import TagGroup from './tag-group'

import styles from './tag.module.css'

/**
 *
 * Tag collection is just a wrapper for the tags. It has the ability to 'group' the tags into one
 * and show the grouped tags in a dropdown, when you click on it.
 *
 * Usage:
 *
 * @example
 * <TagCollection groupTags={true|false} title="filters"><Tag...>...</TagCollection>
 *
 * Notable Props:
 * @property {boolean} [groupTags]: PropTypes.bool - Show the tags as a group.
 * @property {boolean} [isGroupOpen]: PropTypes.bool - Show the group dropdown as open.
 * @property {string} [title]: PropTypes.string - The group name to show. Default: 'tags'
 * @property {function} [onGroupClick]: PropTypes.func - Callback that gets fired, when the  group is clicked.
 */

const propTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    groupTags: PropTypes.bool,
    isGroupOpen: PropTypes.bool,
    onGroupClick: PropTypes.func,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    title: PropTypes.string
}

const defaultProps = {
    isGroupOpen: false,
    onGroupClick: () => {},
    title: 'tags'
}

// We need the class component because of the parent ref
class TagCollection extends Component {
    render() {
        const { className, style } = this.props
        const composedClassName = cx(styles['collection'], className, 't3sel-tag-collection')

        return (
            <div className={composedClassName} style={style}>
                {this.renderTags()}
            </div>
        )
    }

    renderTags() {
        const { children, groupTags, isGroupOpen, onGroupClick, title } = this.props

        if (!groupTags) {
            return <div>{children}</div>
        } else {
            return (
                <TagGroup title={title} isOpen={isGroupOpen} onClick={onGroupClick}>
                    {children}
                </TagGroup>
            )
        }
    }
}

TagCollection.propTypes = propTypes
TagCollection.defaultProps = defaultProps

export default TagCollection
